






















































import Vue from 'vue'
import FacebookIcon from '@/assets/facebook_f_brands.svg'
import TwitterIcon from '@/assets/twitter_brands.svg'
declare global {
  interface Window {
    Beacon: (arg: string) => void
  }
}
export default Vue.extend({
  name: 'Bottom',

  components:{
    FacebookIcon,
    TwitterIcon
  },

  data() {
    return {
      date: new Date(),
      footerMenuItems: [
        // Link names are translated here and not in the template above
        {
          path: '//www.freecycle.org/pages/guidelines',
          name: this.$t("Guidelines"),
        },
        {
          path: 'https://freecycle.org/pages/ModManual/ModResources',
          name: this.$t('Moderator Manual')
        },
        {
          path: 'https://freecycle.org/pages/ModManual/modhelp',
          // path: 'help',  // this would be to make the HS beacon pop up
          name: this.$t('Moderator Help')
        },
        {
          path: 'https://freecycle.org/pages/ModManual/ModTools',
          name: this.$t('Modtools Guide')
        },
        {
          path: '//www.freecycle.org/pages/volunteer',
          name: this.$t('Volunteer')
        },
        {
          path: '//www.freecycle.org/pages/privacy',
          name: this.$t('Privacy'),
        },
        {
          path: '//www.freecycle.org/pages/contact',
          name: this.$t('Contact')
        }
      ],
      path: { home: '/' }
    }
  },
  methods: {
    openHelp() { window.Beacon('open') }
  }
})
